import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'
import ATextField from "@/components/ATextField";
Vue.use(Vuetify);

Vue.component('a-text-field', ATextField)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#006cad',
        secondary: '#DDDDDD',
        accent: '#990000',
        error: '#990000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#E59900',
        appMenu: '#324154',
        appBar: '#EDF0F6',
        appBarT: '#CDD9E1',
        pageHeader: '#2471A3',
        primaryDark: '#004c7a',
        primaryDark2: '#005C94',
        primaryLight1: '#CFDDE5',
        Neutral: '#F4F4F4',
        darkCharcoal: '#333333',
        neutralGray: '#777777',
        neutralGray1: '#999999',
        neutralGray2: '#E6E6E6',
        neutralGrayLight: '#e9edf3',

      },
    },
  },
});
